import React from 'react';
import {CheckboxInputElement} from 'types/documentTemplateElement';
import {DocumentTemplate} from 'types/documentTemplate';
import BaseInputProperties from './BaseInputProperties';

interface CheckboxInputPropertiesProps {
  element: CheckboxInputElement;
  template: DocumentTemplate;
  updateElement: (updatedElement: CheckboxInputElement) => void;
}

const CheckboxInputProperties: React.FC<CheckboxInputPropertiesProps> = ({
  element,
  template,
  updateElement,
}) => {
  return (
    <BaseInputProperties
      element={element}
      template={template}
      updateElement={updateElement}
      hidePlaceholder={true}
    />
  );
};

export default CheckboxInputProperties;
